import React, { useEffect, useRef, useState } from "react";
import {
    FileText,
    Link as LinkIcon,
    FileType2,
    Plus,
    ChevronDown,
    LucideIcon,
} from "lucide-react";

export type NewFolderMenuAction = "page" | "link" | "document";

interface Props {
    onSelect: (action: NewFolderMenuAction) => void;
}

const ITEMS: { action: NewFolderMenuAction; label: string; Icon: LucideIcon }[] = [
    { action: "page", label: "Blank page", Icon: FileText },
    { action: "link", label: "Link", Icon: LinkIcon },
    { action: "document", label: "Add a document", Icon: FileType2 },
];

export default function NewFolderMenu({ onSelect }: Props) {
    const [open, setOpen] = useState(false);
    const wrapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return;
        const handler = (e: MouseEvent) => {
            if (!wrapRef.current?.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [open]);

    function handleClick(action: NewFolderMenuAction) {
        setOpen(false);
        onSelect(action);
    }

    return (
        <div className="m-cat-new-menu" ref={wrapRef}>
            <button
                type="button"
                className="m-btn m-btn-primary"
                onClick={() => setOpen(o => !o)}
            >
                <Plus size={16} /> New <ChevronDown size={14} />
            </button>
            {open && (
                <div className="m-cat-new-menu-popover">
                    {ITEMS.map(({ action, label, Icon }) => (
                        <button key={action} type="button" onClick={() => handleClick(action)}>
                            <Icon size={15} />
                            <span>{label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
